var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubePlay = function SvgYoutubePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F03",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M55.584 25.907c1.72.494 3.081 1.95 3.543 3.79C59.974 33.05 60 40 60 40s0 6.978-.847 10.302c-.462 1.84-1.823 3.297-3.543 3.791C52.503 55 40 55 40 55s-12.503 0-15.61-.907c-1.72-.494-3.08-1.95-3.543-3.79C20 46.95 20 40 20 40s0-6.95.822-10.275c.462-1.84 1.822-3.296 3.543-3.79 3.106-.907 15.61-.935 15.61-.935s12.502 0 15.61.907M46.367 40l-10.372 6.429V33.57z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutubePlay;